var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":"","icon":"","disabled":_vm.disabled,"color":_vm.color},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('v-icon',[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }